import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ConfirmationService } from "primeng/api";
import { GetChatMessageListDto } from "../../../core/models/common/GetChatMessageListDto";
import { SendChatMessageRequestDto } from "../../../core/models/common/SendChatMessageRequestDto";
import { UserTagDto } from "../../../core/models/common/userTagDto";
import { createCommentDto } from "../../../core/models/task-management/createCommentDto";
import { CommentListDto } from "../../../core/models/task-management/getCommentList";
import { OwnersByProject } from "../../../core/models/task-management/getOwnersByProject";
import { getTaskDetailResponse } from "../../../core/models/task-management/getTaskDetailResponse";
import { GetTaskLogDto } from "../../../core/models/task-management/getTaskLogDto";
import { StatusTaskList } from "../../../core/models/task-management/statusTaskDto";
import { UpdateNotificationSetting } from "../../../core/models/task-management/updateNotificationSettingDto";
import { UpdateTaskLine } from "../../../core/models/task-management/updateTaskLineDto";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { SharedService } from "../../../core/services/shared.service";
import { TaskManagementService } from "../../../core/services/task-management.service";
import { PriorityTypeEnums } from "../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { Select, SelectModule } from "primeng/select";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { CommonModule } from "@angular/common";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import { EditorModule } from "primeng/editor";
import { TagModule } from "primeng/tag";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ChatboxComponent } from "../../../shared/components/chatbox/chatbox.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { TaskHeaderComponent } from "../../../shared/components/task-header/task-header.component";
import { GetDocumentDto } from "../../../core/models/task-management/getDcoumentDto";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { CreateProjectOnTaskComponent } from "../create-project-on-task/create-project-on-task.component";
import { catchError, firstValueFrom, map, of, take } from "rxjs";
import { PopoverModule } from "primeng/popover";
import { DividerModule } from "primeng/divider";
@UntilDestroy()
@Component({
  selector: "jni-task-summary",
  templateUrl: "./task-summary.component.html",
  styleUrls: ["./task-summary.component.scss"],
  providers: [ConfirmationService],
  imports: [
    CommonModule,
    ToggleSwitchModule,
    EditorModule,
    SelectModule,
    TagModule,
    OverlayPanelModule,
    DialogModule,
    ConfirmDialogModule,
    ChatboxComponent,
    OrderSummaryComponent,
    TaskHeaderComponent,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ButtonModule,
    InputTextModule,
    CreateProjectOnTaskComponent,
    PopoverModule,
    DividerModule,
  ],
})
export class TaskSummaryComponent implements OnInit {
  @Input() showTaskHeader!: boolean;
  @Input() taskIdSelected = 0;
  @Input() displayTaskDetailModal = false;
  @Output() closeTaskDetailModalEvent = new EventEmitter();

  priorityLevelFiltered: {
    id: number;
    title: string;
    production: boolean;
    color: string;
  }[] = [];
  displayProdWorkflowSummary = false;
  taskType = TaskTypeEnum;
  taskDetail = {} as getTaskDetailResponse;
  comment = "";
  ownerList: UserTagDto[] = [];
  //userList: any;
  workflowId = 0;
  salesOrderId = "";
  chatFirstCurrentDateIndex = 0;
  messageList = [] as GetChatMessageListDto[];
  signalRChatBoxShow = false;
  displayChat = false;
  personnelNumber = "";
  userTagList = [] as UserTagDto[];
  //bacList: any[] = [];
  chatModuleName = "Proposed Project";
  @ViewChild("tagDropdown") tagDropdown!: Select;
  showTagDropdown = false;
  isTextAreaDisabled = false;
  newMessage = "";
  showSmallLoader = false;
  selectedTagId = "";
  saveMessage = "";
  paddedWorkflowId = "";
  displayOrderSummary = false;
  commentList: CommentListDto[] = [];
  selectedTaskStatus!: string;
  taskStatusList: { name: string; value: number }[] = [];
  isRedirected = false;
  isAuthorized = false;
  showAddNewProjectModal = false;
  refreshProjectList = false;
  taskStatus: StatusTaskList[] = [
    {
      id: EnumSalesTaskStatus.New,
      status: "New",
    },
    {
      id: EnumSalesTaskStatus.Blocked,
      status: "Blocked",
    },
    {
      id: EnumSalesTaskStatus.InProgress,
      status: "In Progress",
    },
    {
      id: EnumSalesTaskStatus.InReview,
      status: "In Review",
    },
    {
      id: EnumSalesTaskStatus.Closed,
      status: "Closed",
    },
  ];
  taskStatusProd: StatusTaskList[] = [
    {
      id: WorkflowStatusEnum.ALL,
      status: "All",
    },
    {
      id: WorkflowStatusEnum.Cancelled,
      status: "Cancelled",
    },
    {
      id: WorkflowStatusEnum.Complete,
      status: "Complete",
    },
    {
      id: WorkflowStatusEnum.Delivered,
      status: "Delivered",
    },
    {
      id: WorkflowStatusEnum.InProduction,
      status: "In Production",
    },
    {
      id: WorkflowStatusEnum.OrderWritten,
      status: "Order Written",
    },
    {
      id: WorkflowStatusEnum.PoSent,
      status: "PO Sent",
    },
    {
      id: WorkflowStatusEnum.ProjectCreated,
      status: "Project Created",
    },
    {
      id: WorkflowStatusEnum.ProofApproved,
      status: "Proof Approved",
    },
    {
      id: WorkflowStatusEnum.ProofSent,
      status: "Proof Sent",
    },
    {
      id: WorkflowStatusEnum.RevisionRequested,
      status: "Revision Requested",
    },
    {
      id: WorkflowStatusEnum.Shipped,
      status: "Shipped",
    },
  ];

  private priorityLevel: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "Urgent",
    [PriorityTypeEnums.Source]: "Source",
    [PriorityTypeEnums.Order]: "Order",
    [PriorityTypeEnums.Standard]: "Standard",
  };

  taskLogs: GetTaskLogDto[] = [];
  showScrollTop = false;
  showScrollBottom = false;
  isSummaryView = false;
  showTaskModal = false;
  displayAddTaskModal = false;
  workflowStatusList!: Record<string, number>;
  taskStatusKeyPairsSales: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progress": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };
  descriptionForm!: FormGroup;
  notificationSwitch = true;
  isSalesTask = false;
  showAddTaskSmallLoader = false;

  @ViewChild("taskHeader", { static: false })
  taskHeader!: TaskHeaderComponent;
  @ViewChild("createProjectOnTask", { static: false })
  createProjectOnTask!: CreateProjectOnTaskComponent;

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService,
    private confirmationService: ConfirmationService,
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService,
    private _samplepoListingService: SamplepoListingService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _sharedService: SharedService,
    private _formBuilder: FormBuilder
  ) {
    this._route.params.subscribe(params => {
      if (params["id"]) {
        this.isRedirected = true;
        this.taskIdSelected = parseInt(params["id"]);
        //this.isSummaryView = true; //NO Need as from email link button or task listing same popup will be displayed
      }
    });
  }

  ngOnInit() {
    this.descriptionForm = this._formBuilder.group({
      taskId: [0],
      description: [""],
    });
    this.getWorkflowStatusList();
    this.checkAuthorizedUserTask(this.taskIdSelected);
    // if (!this.isRedirected) {
    //   this.getTaskDetail();
    // } else {
    //   this.checkAuthorizedUserTask(this.taskIdSelected);
    // }
  }

  getTaskDetail() {
    const taskID: number = this.taskIdSelected;
    this.showSmallLoader = true;
    this._taskManagementService
      .getTaskDetails(taskID)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.taskDetail = res.data;
          this.descriptionForm.patchValue({
            taskId: res.data.taskId,
            description: res.data.description,
          });
          const status =
            res.data.taskType === TaskTypeEnum.Sales
              ? this.taskStatus.find(
                  item => res.data.status === item.id,
                  (this.taskStatusList = this.stateKeys(res.data.taskType))
                )
              : this.taskStatusProd.find(
                  item => res.data.status === item.id,
                  (this.taskStatusList = this.stateKeys(res.data.taskType))
                );
          this.getTaskLog();
          this.selectedTaskStatus = status?.status ?? "";
          this.salesOrderId = res.data.salesOrderId ?? "";
          this.workflowId = res.data.projectWorkflowId;
          this.paddedWorkflowId = res.data.projectWorkflowId?.toString();
          this.notificationSwitch = res.data.isNotificationEnabled ?? false;
          this.getComments();
          this.getOwnersByProject(res.data.client);
          this.showSmallLoader = false;
          this.isSalesTask = res.data.taskType === TaskTypeEnum.Sales;
        },
      });
  }

  getWorkflowStatusList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        this.workflowStatusList = {};
        const statusEnums: Record<string, number> = {};
        if (res?.data) {
          res.data.forEach((status: { status: string; id: number }) => {
            if (status.id !== 9) {
              statusEnums[status.status] = status.id;
            }
          });
          this.workflowStatusList = statusEnums;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  stateKeys(taskType: number) {
    if (Number(taskType) === Number(TaskTypeEnum.Production)) {
      return this._sharedService.enumToList(this.workflowStatusList);
    } else {
      return this._sharedService.enumToList(this.taskStatusKeyPairsSales);
    }
  }

  showProdWorkflowModal() {
    this.displayProdWorkflowSummary = true;
  }

  closeWorkflowModal() {
    this.displayProdWorkflowSummary = false;
  }

  showOrderModal() {
    this.displayOrderSummary = true;
  }

  closeOrderModal() {
    this.displayOrderSummary = false;
  }

  downloadFile(url: string) {
    this._sharedService.getFileAsBlob(url).subscribe({
      next: res => {
        const blob = new Blob([res], { type: res.type });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
    });
  }

  clickEdit() {
    this.redirectToEditTask(this.taskIdSelected);
  }

  getPriorityByTitle(id: number): string {
    return this.priorityLevel[id];
  }

  updateFollow() {
    this.showSmallLoader = true;
    this._taskManagementService
      .followTask(this.taskDetail.taskId, !this.taskDetail?.isFollow)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status.toLowerCase() == "success") {
            this.getTaskLog();
            if (this.taskDetail.isFollow) {
              this._toastr.success("Success", "You have unfollowed this task");
            } else {
              this._toastr.success(
                "Success",
                "You are now following this task"
              );
            }
            this.taskDetail.isFollow = !this.taskDetail.isFollow;
          }
        },
      });
  }

  getTaskLog() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getTaskLogs(this.taskDetail.taskId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status.toLowerCase() == "success") {
            this.taskLogs = res.data;
            this.taskLogs.forEach((element: GetTaskLogDto) => {
              element.log = element.log.replace("\n", "<br>");
            });
            // Check if scroll indicators are needed after data loads
            setTimeout(() => this.checkScrollIndicators(), 100);
          }
        },
      });
  }

  onScrollContainer(event: Event) {
    const element = event.target as HTMLElement;
    this.checkScrollIndicators(element);
  }

  private checkScrollIndicators(element?: HTMLElement) {
    if (!element) {
      const container = document.querySelector(".task-logs-container");
      if (!container) return;
      element = container as HTMLElement;
    }

    const { scrollTop, scrollHeight, clientHeight } = element;
    const threshold = 5; // Small threshold to account for floating point precision

    this.showScrollTop = scrollTop > threshold;
    this.showScrollBottom = scrollTop < scrollHeight - clientHeight - threshold;
  }

  checkAuthorizedUserTask(taskId: number) {
    this._loaderService.setLoaderState(true);
    this._taskManagementService
      .isAuthorizedToView(taskId.toString())
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data && res.data === true) {
            this.isAuthorized = true;
            this.getTaskDetail();
          } else {
            this.isAuthorized = false;
            this._toastr.error(
              "Error",
              "You are not authorised to view this task"
            );
            this._router.navigate(["task-management"]);
          }
        },
        error: () => {
          this.isAuthorized = false;
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error checking authorization");
        },
      });
  }

  attachmentDelConfirmation(document: GetDocumentDto, index: number) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this Attachment?",
      accept: () => {
        this.deleteAttachment(document, index);
      },
    });
  }

  tagDelConfirmation(document: number | null, index: number, title: string) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${title} Tag?`,
      accept: () => {
        this.deleteTag(document ?? 0, index);
      },
    });
  }

  async updateTaskStatus() {
    this.showSmallLoader = true;
    try {
      const status = this.taskStatusList.find(
        item => item.name == this.selectedTaskStatus
      );
      if (!status) {
        this._toastr.error("Invalid status selected", "Error");
        return;
      }
      const res = await firstValueFrom(
        this._taskManagementService
          .updateStatus(this.taskDetail.taskId, status.value)
          .pipe(take(1))
      );

      const ok = res.status.toLowerCase() === "success";
      if (!ok) {
        this._toastr.error("Error updating the status", "Error");
        return;
      }

      await firstValueFrom(this.addComment(`Status changed: ${status.name}`));
      this.getTaskLog();
      this._toastr.success(
        "You have successfully updated the Status",
        "Success"
      );
    } catch {
      this._toastr.error("Error updating the status", "Error");
    } finally {
      this.showSmallLoader = false;
    }
  }

  async sendComment(comment: string) {
    this.showSmallLoader = true;
    try {
      const ok = await firstValueFrom(this.addComment(comment));
      if (ok) this._toastr.success("Comment submitted", "Success");
      this.getTaskLog();
    } catch {
      this._toastr.error("Failed to submit comment", "Error");
    } finally {
      this.showSmallLoader = false;
    }
  }

  addComment(comment: string) {
    const commentPayload = {
      comment: comment,
      taskId: this.taskDetail.taskId,
    } as createCommentDto;
    return this._taskManagementService.addCommentinTask(commentPayload).pipe(
      take(1),
      map(res => {
        const ok = (res?.status ?? "").toLowerCase() === "success";
        if (ok) {
          this.comment = "";
          this.getComments();
        }
        return ok;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  getComments() {
    this._taskManagementService
      .getCommentsByTask(
        this.taskDetail.taskId,
        this.taskDetail.projectWorkflowId
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.commentList = res.data;
        },
      });
  }

  getAcronym(word: string) {
    return word?.match(/\b(\w)/g)?.join("");
  }

  deleteAttachment(document: GetDocumentDto, index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .deleteDocumentFromTask(this.taskDetail.taskId, document.documentId ?? 0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getTaskLog();
          this.showSmallLoader = false;
          if (res.status.toLowerCase() === "success") {
            this.taskDetail.documents.splice(index, 1);
            this._toastr.success("Document deleted successfully", "Success");
          }
        },
      });
  }

  getOwnersByProject(client: string) {
    if (client) {
      this._samplepoListingService
        .getBCForSalesOrder(client)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.ownerList = [];
            if (res.data != null && res.data.length > 0) {
              this.ownerList.push({
                userId: res.data[0].personnelNumber,
                name: res.data[0].projectName.replace(/\s+/g, ""),
              });

              this.getBacForSalesOrder(res.data[0].personnelNumber);
            }
          },
        });
    }
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                this.ownerList?.push({
                  userId: item.personnelNumber,
                  name: item.name.replace(/\s+/g, ""),
                });
              }
            });
          }
        },
      });
  }

  // getOwnersByProject(event: any) {
  //   this._taskManagementService
  //     .getOwnersByProject(event)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.userList = res.data;
  //         this.userTagListMapper(res.data);
  //         this.getMessagesList();
  //         res.data.map((item) => {
  //           if (item.coOwnerName != '' || item.ownerName != '') {
  //             this.ownerList.push({
  //               userId:
  //                 item.coOwnerPersonalNumber == ''
  //                   ? item.ownerPersonalNumber
  //                   : item.coOwnerPersonalNumber,
  //               name:
  //                 item.ownerName == ''
  //                   ? item.coOwnerName.replace(/\s+/g, '')
  //                   : item.ownerName.replace(/\s+/g, '')
  //             });
  //           }
  //         });
  //       }
  //     });
  // }

  getMessagesList() {
    const loaderStatus = this._loaderService.status$;
    if (!loaderStatus) {
      this._loaderService.setLoaderState(true);
    }
    this._workflowService
      .getChatMessageList(this.workflowId, "ProductionWorkflow")
      .subscribe({
        next: res => {
          if (res && res.status === "Success") {
            const today = new Date().toDateString();
            const index = res.data.findIndex(item => {
              const itemDate = new Date(item.createdDate);
              return itemDate.toDateString() === today;
            });
            if (index !== -1) {
              this.chatFirstCurrentDateIndex = index;
            }
            this.messageList = res.data;
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to get Chat Messages");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  showChatBox() {
    this.getOwnersByProject(this.taskDetail.client);
  }

  onHide() {
    this.displayChat = false;
  }

  formatMessage(message: string) {
    const regex = /@<[^,]+, ([^>]+)>/g;
    return message.replace(regex, (match, p1) => `<b>@${p1}</b>`);
    //return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  userTagListMapper(data: OwnersByProject[]) {
    const mappedList = data
      .filter(x => {
        if (x.ownerPersonalNumber || x.coOwnerPersonalNumber) {
          return true;
        }
        return false;
      })
      .map(obj => {
        const user = {} as UserTagDto;
        if (obj.ownerPersonalNumber) {
          user.name = obj.ownerName;
          user.userId = obj.ownerPersonalNumber;
          return user;
        } else {
          user.name = obj.coOwnerName;
          user.userId = obj.coOwnerPersonalNumber;
        }
        return user;
      });
    const filteredList = mappedList.filter(
      x => x.userId !== this.personnelNumber
    );
    this.userTagList.push(...filteredList);

    // const mappedBacList = this.bacList
    //   .filter(
    //     (obj) =>
    //       !this.userTagList.some(
    //         (user: UserTagDto) => user.userId === obj.personnelNumber
    //       ) && obj.personnelNumber !== this.personnelNumber
    //   )
    //   .map((obj) => {
    //     const user = {} as UserTagDto;
    //     user.name = obj.name.replace(/\s+/g, '');
    //     user.userId = obj.personnelNumber;
    //     return user;
    //   });
    // this.userTagList.push(...mappedBacList);
  }

  sendChatMessage(event: string) {
    this._loaderService.setLoaderState(true);
    if (!event) {
      this._toastr.error("Error", "Chat Message cannot be empty");
      this._loaderService.setLoaderState(false);
      return;
    }
    const payload = {} as SendChatMessageRequestDto;
    payload.moduleName = "ProductionWorkflow";
    payload.moduleId = this.workflowId.toString();
    payload.message = event;

    this._workflowService.sendChatMessage(payload).subscribe({
      next: res => {
        if (res && res.status === "Success") {
          this.getMessagesList();
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  deleteTag(tagId: number, index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .deleteTag(this.taskDetail.taskId, tagId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getTaskLog();
          this.showSmallLoader = false;
          if (res.status.toLowerCase() === "success") {
            this.taskDetail.tags.splice(index, 1);
            this._toastr.success("Tag deleted successfully", "Success");
          }
        },
      });
  }

  sendMessage() {
    if (!this.comment) {
      this._toastr.error("Add some comment to post!");
      return;
    }
    const mentionRegex = /@([\w.]+@[\w.]+\.\w+)|@(\w+)/g;
    const commentStr = this.comment.replace(
      mentionRegex,
      (match, email, mention) => {
        if (email) {
          return match;
        }
        const user = this.ownerList.find(x => x.name === mention);
        return user ? `@<${user.userId}, ${user.name}>` : match;
      }
    );
    this.sendComment(commentStr);
    this.newMessage = "";
    this.saveMessage = "";
  }

  inputHandler(event: KeyboardEvent) {
    if (event.key === "@") {
      this.showTagDropdown = true;
      setTimeout(() => {
        this.tagDropdown.show();
      }, 0);
    } else {
      this.showTagDropdown = false;
    }
  }

  onTagSelectionChange(value: string) {
    if (value) {
      this.isTextAreaDisabled = true;
      const user = this.ownerList.find(x => x.userId === value);
      this.comment = this.replaceLastOccurrence(
        this.comment,
        "@" + user?.name,
        "@"
      );
      this.showTagDropdown = false;
      this.isTextAreaDisabled = false;
      this.selectedTagId = "";
    } else {
      this.showTagDropdown = false;
    }
  }

  replaceLastOccurrence(
    originalString: string,
    replaceString: string,
    searchString: string
  ): string {
    const lastIndex = originalString.lastIndexOf(searchString);
    if (lastIndex === -1) {
      return originalString;
    }
    const beforeLast = originalString.substring(0, lastIndex);
    const afterLast = originalString.substring(lastIndex + searchString.length);
    return beforeLast + replaceString + afterLast;
  }

  redirectToWorkflowSummary() {
    if (this.workflowId) {
      const url = this._router.serializeUrl(
        this._router.createUrlTree([
          `/project-workflow/workflow-summary/${this.workflowId}/${this.salesOrderId}`,
        ])
      );
      window.open(url, "_blank");
    }
  }

  showAddTask() {
    this.showTaskModal = !this.showTaskModal;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  closeAddTask() {
    this.displayAddTaskModal = false;
    this.getTaskDetail();
  }

  saveDescription() {
    this.showSmallLoader = true;
    const payload = {
      taskId: this.descriptionForm.value.taskId,
      column: "description",
      value: this.descriptionForm.value.description,
    } as UpdateTaskLine;
    this._taskManagementService.UpdateTaskLine(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          this.showSmallLoader = false;
          this._toastr.success("Success", "Task Updated Successfully");
        } else {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to Update Task");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this._toastr.error("Error", "Failed to Update Task");
      },
    });
  }

  switchNotification(event: ToggleSwitchChangeEvent) {
    this.showSmallLoader = true;
    this.notificationSwitch = event?.checked || false;
    const payload = {
      taskId: this.taskIdSelected,
      isEnabled: this.notificationSwitch,
    } as UpdateNotificationSetting;
    this._taskManagementService.updateNotificationSetting(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          this.showSmallLoader = false;
          this._toastr.success(
            "Success",
            "Notification Setting Updated Successfully"
          );
        } else {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to Update Notification Settings");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this._toastr.error("Error", "Failed to Update Notification Settings");
      },
    });
  }

  displayChatDialog() {
    this.displayChat = true;
    this.getMessagesList();
  }

  copyTaskFn() {
    this.confirmationService.confirm({
      message: `Are you sure you want to copy this task?`,
      accept: () => {
        this.showSmallLoader = true;
        this._taskManagementService.CopyTask(this.taskIdSelected).subscribe({
          next: async res => {
            if (res && res.status.toLowerCase() === "success") {
              this.taskDetail = res.data;
              this.taskIdSelected = res.data.taskId;
              this.descriptionForm.patchValue({
                taskId: res.data.taskId,
                description: res.data.description,
              });
              const status =
                res.data.taskType === TaskTypeEnum.Sales
                  ? this.taskStatus.find(
                      item => res.data.status === item.id,
                      (this.taskStatusList = this.stateKeys(res.data.taskType))
                    )
                  : this.taskStatusProd.find(
                      item => res.data.status === item.id,
                      (this.taskStatusList = this.stateKeys(res.data.taskType))
                    );
              this.getTaskLog();
              this.selectedTaskStatus = status?.status ?? "";
              this.salesOrderId = res.data.salesOrderId ?? "";
              this.workflowId = res.data.projectWorkflowId;
              this.paddedWorkflowId = res.data.projectWorkflowId?.toString();
              this.notificationSwitch = res.data.isNotificationEnabled ?? false;
              this.getComments();
              this.getOwnersByProject(res.data.client);
              this.showSmallLoader = false;
              this.isSalesTask = res.data.taskType === TaskTypeEnum.Sales;
              this._toastr.success("Success", "Task copied successfully.");
            } else {
              this._toastr.error("Error", "Failed to copy task.");
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
            this._toastr.error("Error", "Failed to copy task.");
          },
        });
      },
    });
  }

  openAddNewProjectModal() {
    this.createProjectOnTask.clearAddNewProjectModal();
    this.showAddNewProjectModal = true;
  }

  closeAddNewProjectModal() {
    this.showAddNewProjectModal = false;
  }

  refreshProjectGrid(obj: boolean) {
    if (obj === true) {
      this.taskHeader.getAllProjectsForUsers();
    }
  }

  showOrHideAddTaskSmallLoader($event: boolean) {
    this.showAddTaskSmallLoader = $event;
  }

  closeTaskDetailModal() {
    this.closeTaskDetailModalEvent.emit();
  }
}
